import { useState } from 'react';
import { useNavigate } from 'react-router-dom'
import { RemoveLocalStorage, SetLocalStorage, clearLocalStorage } from '../../service/StoreLocalStorage';
import { toast } from 'react-hot-toast';
import { customAxios } from '../../service/CreateApi';

export const Globalcomponent = () => {
    const [loading, setLoading] = useState(false)
    const [Error, setError] = useState([]);

    const navigate = useNavigate();

    //  login function
    const onSubmit = async (data) => {
        setError([]);
        try {
            setLoading(true)
            const res = await customAxios().post('/auth/login', data)
            if (res.data.success) {
                toast.success(res.data.message);
                SetLocalStorage("email", res.data.data);
                navigate("/otp");
            }
        } catch (error) {
            if (!error.response) {
                toast.error(error.message)
            } else if (error.response.data.message) {
                toast.error(error.response.data.message)
            } else if (error.response.data.error) {
                setError(error.response.data.error)
            }
        } finally {
            setLoading(false)
        }
    }

    // otp verify function
    const onSubmitOtp = async (email, otp) => {

        setError([]);

        try {
            setLoading(true)

            const res = await customAxios().patch('/auth/otp', {
                email,
                otp
            })

            if (res.data.success) {
                let { message, id, token,userVerify } = res.data;
                RemoveLocalStorage("email")
                SetLocalStorage("user_id", id)
                SetLocalStorage("token", token)
                toast.success(message);
                if(userVerify){
                    navigate(`/profile/${id}`);
                }else{
                    navigate('/')
                }
            }
        } catch (error) {
            if (!error.response) {
                toast.error(error.message)
            } else if (error.response.data.message) {
                toast.error(error.response.data.message)
            } else {
                if (error.response.data.error) {
                    setError(error.response.data.error)
                }
            }
        } finally {
            setLoading(false)
        }
    }

    // sign out function
    const handleLogout = async () => {
        setLoading(true);
        customAxios().post('/auth/logout').then((res) => {
            if (res.data.success) {
                clearLocalStorage();
                navigate('/login');
                setLoading(false)
                toast.success('Logged out successfully.')
            }
        }).catch((error) => {
            setLoading(false)
            if (!error.response) {
                toast.error(error.message)
            } else if (error.response.data.message) {
                toast.error(error.response.data.message)
            }
        })
    }

    // resend code 
    const HandleResend = async (email) => {
        setError([]);
        try {
            setLoading(true)
            const res = await customAxios().patch('/auth/resendOtp', { email })
            if (res.data.success) {
                toast.success(res.data.message)
            }
        } catch (error) {
            if (!error.response) {
                toast.error(error.message)
            } else if (error.response.data.message) {
                toast.error(error.response.data.message)
            } else if (error.response.data.error) {
                setError(error.response.data.error)
            }
        } finally {
            setLoading(false)
        }
    }

    return {
        onSubmit,
        loading,
        onSubmitOtp,
        handleLogout,
        Error,
        HandleResend
    }
}

